import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";
import { Helpers } from "../helpers";


@JsonConverter
export class VpnConverter implements JsonCustomConvert<Vpn>{
	serialize() { }
	deserialize(data: any): Vpn {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, Vpn);
	}
}

@JsonConverter
export class VpnArrayConverter implements JsonCustomConvert<Array<Vpn>>{
	serialize() { }
	deserialize(data: any): Array<Vpn> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, Vpn);
	}
}

@JsonConverter
export class VpnListConverter implements JsonCustomConvert<VpnList>{
	serialize() { }
	deserialize(data: any): VpnList {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, VpnList);
	}
}

@JsonObject("Vpn")
export class Vpn {
    @JsonProperty("uuid", String, true)
	uuid: string = "";
    @JsonProperty("vpn", [String], true)
	vpn: Array<string> = [];
    @JsonProperty("name", String, true)
	name: string = "";
    @JsonProperty("enabled", Boolean, true)
	enabled: boolean = false;

	isValid() {
		if (!this.name || this.vpn.length === 0) {
			return false;
		} else {
			let isValid = true;
			this.vpn.forEach(v => {
				if (!Helpers.checkIp(v)) {
					isValid = false;
				}
			});
			return isValid;
		}
	}

    dto(){
        return{
            vpn:this.vpn,
            name:this.name,
            enabled:this.enabled
        }
    }
}

@JsonObject("VpnList")
export class VpnList {
	@JsonProperty("count", Number, true)
	count: number = 0;
	@JsonProperty("data", VpnArrayConverter, true)
	data: Array<Vpn> = new Array<Vpn>();
}

@JsonObject("VpnData")
export class VpnData extends BaseResponse {
	@JsonProperty("data", VpnConverter, true)
	data: Vpn = new Vpn();
}

@JsonObject("VpnListData")
export class VpnListData extends BaseResponse {
	@JsonProperty("data", VpnListConverter, true)
	data: VpnList = new VpnList();
}